<template>
  <div class="basic_wrap">
    <div class="login_bg">
      <!-- <div class="back_left" @click="$router.back()"></div> -->
      <div class="big_tit">
        <img
          class="slogo"
          height="20px"
          src="../images/login/slogo.png"
        >
      </div>
      <div
        class="language"
        @click="$router.push('/language')"
      >
        <img :src="require('../images/shop2/lang.png')">
      </div>
    </div>
    <div class="login_logo">
      <img
        class="logo"
        src="../images/shop2/top.jpg"
      >
    </div>
    <div class="form">
      <!--     <div class="cut_login">
                <router-link to="/login">
                    {{$t('register.signIn')}}
                    <div class="line" />
                </router-link>
                <router-link class="cur" to="/register">
                    {{$t('register.signUp')}}
                    <div class="line" />
                </router-link>
            </div> -->
      <div class="item">
        <span class="icon">
          <van-icon
            name="contact"
            size="25"
          />
        </span>
        <input
          v-model.trim="data.name"
          type="text"
          class="inp"
          :placeholder="$t('register.loginacc')"
          @input="handleAccountInput"
        >
      </div>
      <div class="item">
        <span class="icon">
          <van-icon
            name="phone"
            size="25"
          />
        </span>
                
        <span class="area_code">
          <van-popover
            v-model="showPopover" 
            style="padding: 0px 5px;background: #fff;"
            trigger="click"
            placement="right"
            theme="dark"
          >
            <van-grid
              clickable
              :center="false"
              :border="false"
              column-num="1"
              style="width: 100%;font-size: 14px;height: 50vh;overflow: scroll;"
            >
              <van-grid-item
                v-for="(item, index) in actions"
                :key="index"
                :text="item.name+'('+item.code+')'"
                style="font-weight: bolder;"
                @click="showPopover = false;data.acode=item.code;"
              />
            </van-grid>
            <template #reference>
              <button
                type="primary"
                style="font-size: 14px;"
              >{{ data.acode }}</button>
            </template>
          </van-popover>
        </span>
        <input
          v-model.trim="data.mobile"
          type="tel"
          class="inp"
          inputmode="numeric"
          pattern="[0-9]*"
          :placeholder="$t('register.phoneNumber')"
          @input="handleMobileInput"
        >
      </div>
  
      <div class="item">
        <span class="icon">
          <van-icon
            name="lock"
            size="25"
          />
        </span>
        <input
          v-model.trim="data.password"
          :type="password"
          class="inp"
          :placeholder="$t('register.password')"
        >
        <div
          class="eye_bi"
          :class="password == 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div>
      <div class="item">
        <span class="icon">
          <van-icon
            name="lock"
            size="25"
          />
        </span>
        <input
          v-model.trim="data.spassword"
          :type="password"
          class="inp"
          :placeholder="$t('register.spassword')"
        >
        <div
          class="eye_bi"
          :class="password == 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div>
      <!-- <div class="item">
                <input type="text" class="inp" v-model.trim="data.code" :placeholder="$t('forgetpwe.code')"/>
                <van-count-down :time="time" format='mm:ss' class="btn get_captcha" @finish="timeCall">
                    <template v-slot="timeData">
                        <span @click="sendcode">{{timeData.seconds > 0 ? (timeData.minutes+':'+timeData.seconds): $t('forgetpwe.send')}}</span>
                    </template>
                </van-count-down>
            </div> -->
      <!--             <div class="item">
                <input type="password" class="inp" v-model.trim="data.paypwd" placeholder="请输入支付密码" />
            </div>
            <div class="item">
                <input type="password" class="inp" v-model.trim="data.confirm_paypwd" placeholder="请再次输入支付密码" />
            </div> -->
      <!-- <div v-if="show_sms > 0" class="item">
                <input v-model.trim="data.code" type="text" class="inp" :placeholder="$t('register.code')">
                <van-count-down :time="time" format='mm:ss'  class="btn get_captcha" @finish="timeCall">
                    <template v-slot="timeData">
                        <span @click="sendcode">{{
                          timeData.seconds > 0
                            ? timeData.seconds
                            : $t('register.sendCode')
                        }}</span>
                    </template>
                </van-count-down>
            </div> -->
      <template>
        <div class="item">
          <span class="icon">
            <van-icon
              name="friends-o"
              size="25"
            />
          </span>
          <input
            v-model.trim="data.t_mobile"
            type="text"
            class="inp"
            :placeholder="$t('register.referralCode')"
          >
        </div>
      </template>

      <div class="agreement-row">
        <van-checkbox
          v-model="agreementChecked"
          icon-size="14px"
          checked-color="#1989fa"
        >
          <span class="agreement-text">{{ $t('register.agree') }}</span>
        </van-checkbox>
        <button
          type="button"
          class="agreement-link"
          @click="openAgreement"
        >
          {{ agreementArticle.title || $t('register.userAgreement') }}
        </button>
      </div>

      <div
        class="basic_btn sbtn"
        :class="
          data.mobile == '' ||
            data.password == '' ||
            data.spassword != data.password
            ? 'no_touch'
            : ''
        "
        @click="submit"
      >
        {{ $t('register.register') }}
      </div>
      <div class="register">
        {{ $t('register.signIn') }}<router-link
          class="link"
          to="/login"
        >
          {{ $t('register.signUp') }}
        </router-link>
      </div>
    </div>

    <van-dialog
      v-model="agreementVisible"
      class="agreement-dialog"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
    >
      <div class="agreement-popup">
        <button
          type="button"
          class="agreement-close"
          @click="agreementVisible = false"
        >
          <van-icon name="cross" />
        </button>
        <h3>{{ agreementArticle.title || $t('register.userAgreement') }}</h3>
        <!-- eslint-disable vue/no-v-html -->
        <div
          class="agreement-content"
          v-html="agreementArticle.content"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </van-dialog>
    <!--     <div v-if="msg_show" class="kefu" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
            <img class="kefu_img" src="../images/shop2/kefu.jpg">
        </div> -->
  </div>
</template>

<script>
    import Vue from "vue";
    import {
        Icon,
        CountDown,
        Popover,
        Grid,
        GridItem ,
        Checkbox,
        Dialog,
        Toast
    } from "vant";
    import Fetch from "../../utils/fetch";

    Vue.use(CountDown)
        .use(Popover)
        .use(Grid)
        .use(GridItem)
        .use(Checkbox)
        .use(Icon)
        .use(Dialog)
        .use(Toast);

    export default {
        name: "Register",
        data() {
            return {
                time: 0,
                agreementChecked: true,
                agreementVisible: false,
                agreementArticleId: 38,
                agreementArticle: {
                    title: "",
                    content: "",
                },
                lang:this.$i18n.locale||"en_us",
                show_kefu: false,
                msg_show: true,
                show_sms: 0,
                showPopover: false,
                actions: [
                ],
                password: "password",
                data: {
                    password: "",
                    spassword: "",
                    paypwd: "",
                    name: "",
                    mobile: "",
                    t_mobile: "",
                    telacc: "",
                    acode: "+ 81",
                    code: "",
                    agent: 10000
                },
                config: {}
            };
        },
        created() {
            this.$parent.footer("user", false);
            this.getparams();
            // 安卓返回IMEI，苹果返回UID值
            /*BSL.PhoneID('callName');
            window.callName = this.methodName;
            // 获取手机OAID
            BSL.GetOAID('getExternalInfo');
            window.getExternalInfo = this.getExternalInfoData; */
        },
        mounted() {
            if (this.$route.query.agent) {
                localStorage.setItem('agent', this.$route.query.agent);
                this.data.agent = this.$route.query.agent;
            } else {
                if (localStorage.getItem('agent')) {
                    this.data.agent = localStorage.getItem('agent');
                }
            }
            var that = this;
            document.body.addEventListener(
                "scroll",
                function() {
                    if (!that.show_kefu) {
                        return;
                    }
                    that.show_kefu = false;
                },
                false
            );
            document.addEventListener(
                "click",
                function(ev) {
                    if (ev.target.className != "kefu_img") {
                        that.show_kefu = false;
                    }
                },
                false
            );
            Fetch('/index/webconfig', {
                type: 'web'
            }).then(res => {
                this.config = res.data
                var codes = res.data.codes;
                this.show_sms = res.data.sms_verify
                if(codes && codes.length>0){
                    for (let i = 0; i < codes.length; i++) {
                        this.actions.push({
                            code: ' + ' +codes[i].pcode,
                            name:  '  ' +codes[i].lang
                        })
                    }
                }
            })
        },
        methods: {
            kefu_to() {
                if (this.show_kefu) {
                    this.$router.push("/kefu");
                }
                this.show_kefu = !this.show_kefu;
            },
            showPwd() {
                if (this.password == "password") {
                    this.password = "text";
                } else {
                    this.password = "password";
                }
            },
            methodName(r) {
                this.data.imei = r;
            },
            getExternalInfoData(info) {
                var parsedInfo = JSON.parse(info);
                console.log(parsedInfo);
                if (parsedInfo.code == 0) {
                    this.data.oaid = parsedInfo.oaid;
                }
            },
            getparams() {
                var m = this.$route.query.m;
                if(m && parseInt(m)>0){
                    localStorage.setItem('t_mobile', m);
                    this.data.t_mobile = m;
                }else{
                    if (localStorage.getItem('t_mobile')) {
                        this.data.t_mobile = localStorage.getItem('t_mobile');
                    }
                }
            },
            timeCall() {
                this.is_send = false;
                this.time = 0;
            },
            filterAccount(value) {
                return String(value || '').replace(/[^A-Za-z0-9]/g, '');
            },
            filterDigits(value) {
                return String(value || '').replace(/\D/g, '');
            },
            handleAccountInput() {
                this.data.name = this.filterAccount(this.data.name);
            },
            handleMobileInput() {
                this.data.mobile = this.filterDigits(this.data.mobile);
            },
            openAgreement() {
                if (this.agreementArticle.content) {
                    this.agreementVisible = true;
                    return;
                }

                Fetch("/index/article_detail", {
                    id: this.agreementArticleId,
                }, null, true).then((res) => {
                    this.agreementArticle = {
                        title: res.data.title || this.$t('register.userAgreement'),
                        content: res.data.content || "",
                    };
                    this.agreementVisible = true;
                });
            },
            sendcode() {
                if (this.is_send) {
                    return;
                }

                this.handleMobileInput();
                if (!this.data.mobile) {
                    this.$toast(this.$t('register.phoneEmpty'));
                    return;
                }

                this.is_send = true;

                Fetch("/index/register_code", {
                        mobile: this.data.mobile,
                    })
                    .then(() => {
                        this.time = 120 * 1000;
                        this.$toast({
                            background: "#07c160",
                            message: this.$t('register.sendSuccess'),
                        });
                    })
                    .catch(() => {
                        this.is_send = false;
                    });
            },
            submit() {
                this.handleAccountInput();
                this.handleMobileInput();
                if (!this.data.name) {
                    this.$toast(this.$t('register.loginaccEmpty'));
                    return false;
                }
                if (!this.data.mobile) {
                    this.$toast(this.$t('register.phoneEmpty'));
                    return false;
                }
                if (!this.data.password) {
                    this.$toast(this.$t('register.passwordEmpty'));
                    return false;
                }
                if (!this.agreementChecked) {
                    this.$toast(this.$t('register.agreementRequired'));
                    return false;
                }
                

                if (!this.data.code && this.config.sms_verify) {
                    this.$toast(this.$t('register.codeEmpty'));
                    return false;
                }
                // if (this.data.password != this.data.spassword) {
                //     this.$toast(this.$t('register.passwordError'));
                //     return false;
                // }

                Fetch("/index/register", {
                    password: this.data.password,
                    spassword: this.data.spassword,
                    paypwd: this.data.paypwd,
                    name: this.data.name,
                    mobile: this.data.mobile,
                    t_mobile: this.data.t_mobile,
                    telacc: this.data.telacc,
                    code: this.data.code,
                    agent: this.data.agent
                }).then((res) => {
                    if (res.data.token) {
                        localStorage.setItem('token', res.data.token);
                    }
                    this.$toast(this.$t('register.signUpSuccess'));
                    this.$router.replace("/");
                });
            },
            changeLang(lang) {
                Toast.loading({
                    // mask: true,
                    duration: 200
                })
                this.lang = lang;
                this.$i18n.locale = lang;
                localStorage.setItem("lang", lang);
                this.$router.go(-1);
            }
        },
    };
</script>

<style lang="less" scoped>
    .login_bg {
        width: 100%;
        height: 48px;
        // background: none;
        background-size: 100% 100%;
        overflow: hidden;
        position: relative;
        .language{
            position: absolute;
            top: 4px;
            right: 0;
            height: 36px;
            img{
                height: 100%;
            }
        }
    }

    .basic_wrap .form {
        margin: 5px auto 0 auto;
        width: 95%;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
        border-radius: 13px;
        padding: 31px 24px 31px 24px;
    }

    .cut_login {
        width: 207px;
        line-height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        text-align: center;
        margin: 0 auto;

        a {
            width: 50%;
            padding-bottom: 10px;
            color: #808080;
            position: relative;

            .line {
                width: 100%;
                height: 1px;
                position: absolute;
                left: 0;
                bottom: 0;
                background-color: #f2f2f2;
            }
        }

        a.cur {
            color: #ee264d;;

            .line {
                height: 2px;
                background-image: linear-gradient(to right, #ee264d, #f18a11);
            }
        }
    }
    .big_tit{
        color: #000;
    }
    .block {
        width: 100%;
        height: 100%;
        // overflow:hidden;
        // margin: 10% auto;
        font-size: 15px;
        justify-content: center;
        background-color: #fff;
        border-radius: 5px;

        .block-title {
            display: block;
            font-weight: bolder;
            line-height: 39px;
            height: 39px;
            text-align: center;
        }

        .p_agr {
            // padding-top:30rpx;
            font-size: 12px;
            /*font-weight: bolder;*/
            line-height: 20px;
            padding: 0px 10px;
            height: 388px;
            /*overflow: hidden;*/
            // overflow: auto;
            -webkit-overflow-scrolling: touch;
            overflow-y: scroll;
        }

        .div_qd {
            width: 60px;
            height: 25px;

            span {
                width: 60px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                justify-content: center;
                background: #fb661e;
                border-radius: 10px;
                padding: 1px 5px;
                color: #fff;
            }

            margin: 10px auto;
        }
    }

    .item {
        height: 58px;
        border-bottom: 1px solid #f0f1f3;
        font-size: 14px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        padding-bottom: 4px;

        .icon {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 28px;
            height: 24px;

            .people {
                width: 23px;
                height: 20px;
            }

            img {
                height: 100%;
            }
        }

        input {
            height: 20px;
            margin-left: 7px;
            flex: 1;
            margin-bottom: 3px;
        }
    }

    .get_captcha {
        width: 88px;
        height: 34px;
        background: linear-gradient(90deg,
                rgba(228, 57, 46, 1) 0%,
                rgba(254, 76, 22, 1) 100%);
        border-radius: 4px;
        text-align: center;
        line-height: 34px;
        font-size: 14px;
        color: #ffffff;
    }

    .protocol {
        font-size: 12px;
        line-height: 17px;
        margin-top: 20px;
        color: #999999;

        a {
            color: #3d96ff;
        }
    }

    .basic_btn {
        margin: 36px auto 0 auto;
    }
    /deep/ .van-icon {
    }
    .login_logo {
        width: 100%;
        color: #fff;
        text-align: center;
        -webkit-animation: bot_top-data .3s;
        animation: bot_top-data .3s;
    }
    .login_logo img {
        -webkit-animation: logobig-data 1.2s;
        animation: logobig-data 1.2s;
        width: 100%;
        margin-bottom: 10px;
        border-radius: 10px;
    }
    .form{
        -webkit-animation: bot_top-data .3s;
        animation: bot_top-data .3s;
    }
    @-webkit-keyframes bot_top-data {
        0% {
            margin-top: 1000px;
            opacity: 0;
        }
        100% {
            margin-top: 0;
            opacity: 1;
        }
    }
    
    @keyframes bot_top-data {
        0% {
            margin-top: 1000px;
            opacity: 0;
        }
        100% {
            margin-top: 0;
            opacity: 1;
        }
    }
    @-webkit-keyframes logobig-data{
        0% {
            -webkit-transform: scale(.3);
            opacity: 0;
        }
        50% {
            -webkit-transform: scale(1.2);
            opacity: .5;
        }
        100% {
            -webkit-transform: scale(1);
            opacity: 1;
        }
    }
    @keyframes logobig-data{
        0% {
            -webkit-transform: scale(.3);
            opacity: 0;
        }
        50% {
            -webkit-transform: scale(1.2);
            opacity: .5;
        }
        100% {
            -webkit-transform: scale(1);
            opacity: 1;
        }
    }
    .register{
        line-height: 5%;
        text-align: center;
        margin-top: 30px;
        font-size: 12px;
    }
    
    .basic_wrap {
        min-height: 100%;
        max-width: 750px;
        // background: url(../images/shop2/1.png) no-repeat top;
        // background-size: 100% 100%;
        // background-color: #FFF;
    }
    .big_tit {
        font-size: 16px;
        font-weight: 500;
        line-height: 25px;
        padding: 10px;
        display: block;
        position:relative;
        top: auto;
    }
    .area_code{
        font-size: 16px;
        line-height: 28px;
        width: 60px;
        // color: #ee264d;
        display: block;
        font-weight: bold;
    }
    /deep/ .van-popover{
        width: 128px;
    }
    /deep/ .van-popover__action{
        width: auto !important; 
    }
    /deep/ .van-grid-item__content{
        padding: 8px;
    }
    /deep/ .van-popover__content{
        width: 220px;
    }

    .basic_wrap {
        min-height: 100vh;
        height: auto;
        overflow-y: auto;
        padding-bottom: 32px;
        box-sizing: border-box;
        background: #eef7ff;
        color: #07152b;
    }

    .login_bg {
        height: 120px;
        overflow: visible;
        background: linear-gradient(135deg, #ffd927 0%, #ffb01f 48%, #ff8418 100%);
    }

    .big_tit {
        height: 44px;
        display: flex;
        align-items: center;
        padding: 12px 22px 0;
        box-sizing: border-box;
        line-height: 1;
    }

    .slogo {
        height: 18px;
        max-width: 150px;
        object-fit: contain;
    }

    .login_bg .language {
        top: 16px;
        right: 24px;
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        background: rgba(255, 255, 255, .9);
        box-shadow: 0 6px 14px rgba(21, 44, 78, .08);
    }

    .login_bg .language img {
        width: 22px;
        height: 22px;
        object-fit: contain;
    }

    .login_logo {
        position: relative;
        z-index: 2;
        width: auto;
        margin: -24px 16px 0;
        padding: 8px;
        border-radius: 10px;
        background: #fff;
        box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
        -webkit-animation: none;
        animation: none;
        box-sizing: border-box;
    }

    .login_logo img {
        display: block;
        width: 100%;
        height: 88px;
        margin: 0;
        border-radius: 8px;
        -webkit-animation: none;
        animation: none;
        object-fit: cover;
    }

    .basic_wrap .form {
        width: auto;
        margin: 18px 16px 0;
        padding: 16px 18px 18px;
        border-radius: 10px;
        background: #fff;
        box-shadow: none;
        -webkit-animation: none;
        animation: none;
        box-sizing: border-box;
    }

    .item {
        height: 54px;
        align-items: center;
        padding: 0;
        border-bottom: 1px solid #eef0f2;
    }

    .item .icon {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #8aa9d5;
        font-size: 20px;
    }

    .item input {
        min-width: 0;
        height: 34px;
        margin: 0 0 0 8px;
        color: #172033;
        font-size: 14px;
        line-height: 34px;
    }

    .item input::placeholder {
        color: #aeb4bf;
    }

    .agreement-row {
        min-height: 42px;
        margin-top: 14px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        border-radius: 8px;
        background: #f7f8fc;
        box-sizing: border-box;
    }

    .agreement-text {
        color: #172033;
        font-size: 12px;
        line-height: 18px;
    }

    .agreement-link {
        margin-left: 4px;
        padding: 0;
        border: 0;
        border-bottom: 1px solid #ff4d4f;
        background: transparent;
        color: #172033;
        font-size: 12px;
        line-height: 18px;
    }

    .agreement-popup {
        position: relative;
        padding: 24px 18px 20px;
        box-sizing: border-box;
        background: #fff;
    }

    .agreement-popup h3 {
        margin: 0 32px 18px;
        color: #061429;
        font-size: 18px;
        font-weight: 500;
        line-height: 24px;
        text-align: center;
    }

    .agreement-close {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 28px;
        height: 28px;
        padding: 0;
        border: 0;
        background: transparent;
        color: #8a93a3;
        font-size: 18px;
        line-height: 28px;
    }

    .agreement-content {
        max-height: 68vh;
        overflow-y: auto;
        color: #0f2b45;
        font-size: 14px;
        line-height: 22px;
        word-break: break-word;
        -webkit-overflow-scrolling: touch;
    }

    .agreement-content /deep/ p {
        margin: 0 0 12px;
    }

    .agreement-content /deep/ p:last-child {
        margin-bottom: 0;
    }

    .agreement-content /deep/ img {
        max-width: 100%;
        height: auto;
        border-radius: 8px;
    }

    /deep/ .agreement-dialog {
        width: 90%;
        max-width: 520px;
        border-radius: 14px;
    }

    .area_code {
        flex: 0 0 58px;
        width: 58px;
        color: #172033;
        font-size: 14px;
        font-weight: 700;
        line-height: 32px;
    }

    .area_code button {
        width: 52px;
        height: 30px;
        padding: 0;
        border: 0;
        border-radius: 8px;
        background: #f7f8fc;
        color: #172033;
        font-size: 12px;
        font-weight: 700;
        line-height: 30px;
    }

    .eye_bi {
        flex: 0 0 21px;
        margin-left: 10px;
        opacity: .7;
    }

    .basic_btn {
        width: 100%;
        height: 44px;
        margin: 22px 0 0;
        border-radius: 10px;
        background: linear-gradient(135deg, #ffb01f 0%, #ff8418 100%);
        box-shadow: 0 8px 18px rgba(255, 132, 24, .18);
        color: #fff;
        font-size: 14px;
        font-weight: 700;
        line-height: 44px;
    }

    .basic_btn.no_touch {
        color: rgba(255, 255, 255, .65);
        opacity: .78;
    }

    .register {
        margin-top: 16px;
        color: #4b5563;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
    }

    .register .link {
        margin-left: 6px;
        color: #ff8418;
        font-weight: 700;
    }

    /deep/ .van-popover__content {
        overflow: hidden;
        border-radius: 10px;
        background: #fff;
    }

    /deep/ .van-grid-item__content {
        padding: 8px 10px;
        color: #172033;
        font-size: 12px;
        line-height: 18px;
    }
</style>
